import { setupFidesListeners } from '@core/analytics/consentHelpers';
import { useAuth } from '@auth/oauth/AuthProvider';
import { isPathAllowed } from '@members/modal/Modal';

declare global {
  interface Window {
    insertFidesScript: () => void;
  }
}

export const useFides = () => {
  const { isLoading, isAuthenticated } = useAuth();

  const maybeLoadFides = async () => {
    if (
      !isLoading &&
      isAuthenticated &&
      isPathAllowed(window.location.pathname) &&
      !window.Fides?.initialized
    ) {
      setupFidesListeners();
      window.insertFidesScript();
    }
  };

  return {
    maybeLoadFides,
  };
};
